import convert from "convert-units";

import type { SystemOfMeasurement } from "fond/types/project";

/**
 * Converts square miles to square metres.
 */
export function sqMilesToSqMetres(squareMiles: number): number {
  return convert(squareMiles).from("mi2").to("m2");
}

/**
 * Converts square metres to square miles.
 */
export function sqMetresToSqMiles(squareMeters: number): number {
  return convert(squareMeters).from("m2").to("mi2");
}

export function sqMetresToSqKilometers(squareMeters: number): number {
  return convert(squareMeters).from("m2").to("km2");
}

export function sqMetresToSqFeet(squareMeters: number): number {
  return convert(squareMeters).from("m2").to("ft2");
}

/**
 * Formats an area in square metres as square miles (imperial) or square kilometres (metric) to one decimal place, e.g. "1.4 mi²",
 * or "Less than 1 mi²" below one unit.
 */
export function formatArea(squareMetres: number, systemOfMeasurement: SystemOfMeasurement): string {
  const isImperial = systemOfMeasurement === "imperial";
  const unit = isImperial ? "mi²" : "km²";
  const value = isImperial ? sqMetresToSqMiles(squareMetres) : sqMetresToSqKilometers(squareMetres);
  if (value < 1) return `Less than 1 ${unit}`;
  return `${value.toLocaleString(undefined, { maximumFractionDigits: 1 })} ${unit}`;
}
